import { computed } from "vue";

import type { Table } from "@tanstack/vue-table";

export const useSkeletonArray = <T>(
  table: Table<T>,
  defaultPageSize: number,
) => {
  const skeletonArray = computed(() => {
    const columns = table.getVisibleFlatColumns();
    const arr = [];

    for (let i = 0; i < defaultPageSize; i++) {
      const element: Record<string, string> = {};

      for (let j = 0; j < columns.length; j++) {
        Object.assign(element, {
          [columns[j].id]: "",
        });
      }

      arr.push(element);
    }

    return arr;
  });

  return skeletonArray;
};
